import {
  InfluencerRateCardPayload,
  namedOperations,
  useUpdateInfluencerRateCardsByStaffMutation
} from '@anytag/graphql';
import { Button, Form, Label, Popover } from '@anytag/shared-atoms';
import { useQueryHelper } from '@anytag/shared-hooks';
import { PostsPrice, PostsPriceFormValues } from '../../Influencer';
import { SocialMediasWithNumber } from './SocialMediasWithNumber';
import { getPostPriceOptions } from './utils';

interface PostPricesProps {
  influencerId: number;
  data?: InfluencerRateCardPayload | null;
}
export const PostPrices = ({ influencerId, data }: PostPricesProps) => {
  const { t, enqueueSnackbar } = useQueryHelper();
  const { callUpdateInfluencerRateCardsByStaff, loading } = useUpdateInfluencerRateCardsByStaffMutation({
    refetchQueries: [namedOperations.Query.GetInfluencerRateCard]
  });

  const handleSubmit =
    (closePopup: () => void) =>
    async ({ rateCards }: PostsPriceFormValues) => {
      try {
        await callUpdateInfluencerRateCardsByStaff({
          variables: {
            input: {
              influencerId,
              rateCards: {
                tiktok: rateCards.tiktok !== '' ? { price: +rateCards.tiktok } : null,
                youtube: rateCards.youtube !== '' ? { price: +rateCards.youtube } : null,
                twitter: rateCards.twitter !== '' ? { price: +rateCards.twitter } : null,
                threads: rateCards.threads !== '' ? { price: +rateCards.threads } : null,
                facebook: rateCards.facebook !== '' ? { price: +rateCards.facebook } : null,
                instagram: rateCards.instagram !== '' ? { price: +rateCards.instagram } : null,
                instagramStory: rateCards.instagramStory !== '' ? { price: +rateCards.instagramStory } : null
              }
            }
          }
        });

        closePopup();
      } catch (error) {
        enqueueSnackbar(t(error.message), { variant: 'error' });
      }
    };

  return (
    <Popover
      side="bottom"
      align="center"
      target={({ isOpen, togglePopover }) => (
        <div className="pseudo-hover mt-2" onClick={togglePopover}>
          <div className="flex items-center justify-between">
            <h3 className="text-sm">{`${t('post price')}${data?.currencyId ? ` (${t(data.currencyId)})` : ''}`}</h3>
            {!isOpen ? (
              <button className="cursor-pointer text-sm text-active hover:opacity-80">{t('Button.Edit')}</button>
            ) : null}
          </div>
          <SocialMediasWithNumber currency={data?.currencyId} className="mt-2" data={getPostPriceOptions(data)} />
        </div>
      )}
    >
      {({ togglePopover }) => (
        <Form.Provider<PostsPriceFormValues>
          onSubmit={handleSubmit(togglePopover)}
          className="w-[calc(var(--influencer-profile-intro-width)+16px)]"
        >
          <Form.Body className="rounded-b-[inherit] p-4">
            <Label title={t('post price')} className="font-semibold" />
            <PostsPrice influencerId={influencerId} isProfilePage />
            <Button type="submit" variant="solid" title={t('Save')} loading={loading} className="mt-2 h-7 w-full" />
          </Form.Body>
        </Form.Provider>
      )}
    </Popover>
  );
};
